import React from 'react';
import Input from '../../../components/ui/Input';
import Select from '../../../components/ui/Select';
import { cn } from '../../../utils/cn';

const DoseInput = ({ value, onChange, peptides }) => {
  const units = ['mg', 'mcg'];

  const peptideOptions = peptides?.map((p, index) => ({
    value: index,
    label: p?.name
  }));

  return (
    <div className="space-y-4">
      {peptides?.length > 1 && (
        <Select
          label="Select Peptide"
          options={peptideOptions}
          value={value?.peptideIndex}
          onChange={(val) => onChange({ ...value, peptideIndex: val })}
          placeholder="Choose peptide"
        />
      )}
      
      <div className="space-y-3">
        <label className="text-sm font-medium text-foreground block">
          {peptides?.[value?.peptideIndex]?.name || 'Peptide 1'} Dose
        </label>
        <div className="flex items-center gap-3">
          <Input
            type="number"
            value={value?.value}
            onChange={(e) => onChange({ ...value, value: e?.target?.value })}
            placeholder="0"
            min="0"
            step="0.01"
            className="flex-1"
          />
          <div className="flex gap-2">
            {units?.map((unit) => (
              <button
                key={unit}
                onClick={() => onChange({ ...value, unit })}
                className={cn(
                  "px-4 py-2 rounded-lg border-2 transition-all font-medium",
                  value?.unit === unit
                    ? "border-primary bg-primary text-primary-foreground"
                    : "border-border bg-card text-foreground hover:border-primary/50"
                )}
              >
                {unit}
              </button>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default DoseInput;